import React, { Component, Fragment } from 'react';
import { withAsyncActions } from 'react-async-client';
import { Field } from 'formik';
import yup from 'yup';
import { Button, Row, Col } from 'antd';

import { postUserBilling, patchUserBilling } from 'actions/asyncActions';
import withAutoFocusForm from 'components/hocs/withAutoFocusForm';
import withForm from 'components/hocs/withForm';
import Input from 'components/common/form/Input';

const validationSchema = yup.object({
    isIndividual: yup.boolean(),
    inn: yup.string().Integer().required().min(10).max(12),
    bank: yup.string().trim().required(),
    checking_account: yup.string().Integer().required().length(20),
    bic: yup.string().Integer().required().length(9),
    cpp: yup.string().Integer().required().length(9),
    corr_account: yup.string().Integer().required().length(20),
    snils: yup.string().length(11).when('isIndividual', {
        is: true,
        then: yup.string().trim().required()
    }),
    inn_bank: yup.string().length(10).when('isIndividual', {
        is: true,
        then: yup.string().Integer().required()
    }),
});

@withAutoFocusForm
@withAsyncActions(({ isEdit }) => ({
    formAction: isEdit ? patchUserBilling : postUserBilling
}))
@withForm({
    validationSchema: validationSchema,
})
export default class ProfileBillingForm extends Component {
    render() {
        const { isIndividual } = this.props;

        return (
            <Fragment>
                <Row className="card-info-form">
                    <Col className="card-info-label" xs={12}>
                        ИНН
                    </Col>
                    <Col xs={12}>
                        <Field
                            name='inn'
                            component={Input}
                            placeholder='ИНН'
                        />
                    </Col>
                </Row>
                <Row className="card-info-form">
                    <Col className="card-info-label" xs={12}>
                    Банк
                    </Col>
                    <Col xs={12}>
                        <Field
                            name='bank'
                            component={Input}
                            placeholder='Банк'
                        />
                    </Col>
                </Row>
                <Row className="card-info-form">
                    <Col className="card-info-label" xs={12}>
                    Р/С
                    </Col>
                    <Col xs={12}>
                        <Field
                            name='checking_account'
                            component={Input}
                            placeholder=' Р/С'
                        />
                    </Col>
                </Row>
                <Row className="card-info-form">
                    <Col className="card-info-label" xs={12}>
                    БИК
                    </Col>
                    <Col xs={12}>
                        <Field
                            name='bic'
                            component={Input}
                            placeholder='БИК'
                        />
                    </Col>
                </Row>
                <Row className="card-info-form">
                    <Col className="card-info-label" xs={12}>
                    КПП
                    </Col>
                    <Col xs={12}>
                        <Field
                            name='cpp'
                            component={Input}
                            placeholder='КПП'
                        />
                    </Col>
                </Row>
                <Row className="card-info-form">
                    <Col className="card-info-label" xs={12}>
                    Кор. счет
                    </Col>
                    <Col xs={12}>
                        <Field
                            name='corr_account'
                            component={Input}
                            placeholder='Кор. счет'
                        />
                    </Col>
                </Row>

                { isIndividual && (
                    <Fragment>
                        <Row className="card-info-form">
                            <Col className="card-info-label" xs={12}>
                            СНИЛС
                            </Col>
                            <Col xs={12}>
                                <Field
                                    name='snils'
                                    component={Input}
                                    placeholder='СНИЛС'
                                />
                            </Col>
                        </Row>
                        <Row className="card-info-form">
                            <Col className="card-info-label" xs={12}>
                            ИНН Банка
                            </Col>
                            <Col xs={12}>
                                <Field
                                    name='inn_bank'
                                    component={Input}
                                    placeholder='ИНН Банка'
                                />
                            </Col>
                        </Row>
                    </Fragment>
                )}
                <Row className="form-row">
                    <Button type='primary' htmlType='submit'>
                        Сохранить
                    </Button>
                </Row>
            </Fragment>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/pages/profile/ProfileBillingForm.js